package com.essntl.features.contact.data.supabase

import com.essntl.features.contact.domain.model.GetContactModel
import kotlinx.serialization.Serializable

@Serializable
data class GetContactDto(
    val id: String,
    val name: String,
) {
    fun toModel() =
        GetContactModel(
            id = id,
            name = name,
        )
}